export function SkeletonCard({ className, aspect = 'aspect-3/4' }) {
  return (
    <div className={`flex flex-col animate-pulse ${className}`}>
      <div className={`relative w-full mb-2 overflow-hidden border-0 ${aspect} bg-neutrals-light-grey`}></div>
      <div className="mb-3 min-h-[22px] w-1/2"></div>
      <div className="mb-1 min-h-[20px] w-3/4"></div>
      <div className="mb-1 min-h-[20px] w-1/6"></div>
      <div className="mb-1 min-h-[20px] w-1/3"></div>
    </div>
  )
}
